import React, { useEffect, useState } from 'react';
import TranslatableField from '../../../TranslatableField';
import { Feedback, useSectionFeedback } from './sectionFeedback';

const TRANSLATIONS_ENDPOINT = '/v1/seller/storefront/translations';

const FIELDS = [
    ['sidebarMarketTitle', 'Sidebar Market Title', 'My Market', 30],
    ['sidebarLinksTitle', 'Sidebar Links Title', 'My Links', 30],
    ['hpMarketTitle', 'Landing Page Market Title', 'My Mayhem Market', 60],
    ['hpMarketSubtitle', 'Landing Page Market Subtitle', 'Get access to exclusive products', 60],
    ['hpLinksTitle', 'Landing Page Links Title', 'My Links', 60],
    ['hpLinksSubtitle', 'Landing Page Links Subtitle', 'Check out my other profiles and websites', 60],
    ['hpFriendsTitle', 'Landing Page Friends Title', 'My Fave Mayhem Makers', 60],
    ['hpFriendsSubtitle', 'Landing Page Friends Subtitle', 'Check out these other Mayhem Makers I recommend', 60],
];

export default function TextCopySection({ data, saving, onSave, actions }) {
    const branding = data?.branding || {};
    const [form, setForm] = useState({});
    const { feedback, showFeedback } = useSectionFeedback();

    useEffect(() => {
        setForm(FIELDS.reduce((next, [key]) => ({ ...next, [key]: branding[key] || '' }), {}));
    }, [branding]);

    function handleSave() {
        onSave(async () => {
            const result = await actions.saveTextCopy(form);
            showFeedback(result.success ? 'success' : 'error', result.success ? 'Custom text saved.' : result.error);
            return result;
        });
    }

    return (
        <div>
            <div className="sfm-section-header">
                <h2>Custom Site Text</h2>
                <p>Override default labels and headings on your landing page and storefront.</p>
            </div>
            {FIELDS.map(([key, label, placeholder, maxLength]) => (
                <div className="group" key={key}>
                    <div className="translatable-label">
                        <label htmlFor={`sfm-${key}`}>{label}</label>
                        <TranslatableField
                            endpoint={TRANSLATIONS_ENDPOINT}
                            field={`branding.${key}`}
                            label={label}
                            sourceValue={form[key] || ''}
                            defaultLanguage={data?.defaultLanguage}
                            maxLength={maxLength}
                            translations={data?.translations}
                            onTranslationsChange={actions.setTranslations}
                        />
                    </div>
                    <input
                        id={`sfm-${key}`}
                        maxLength={maxLength}
                        type="text"
                        value={form[key] || ''}
                        placeholder={placeholder}
                        onChange={event => setForm(prev => ({ ...prev, [key]: event.target.value }))}
                    />
                </div>
            ))}
            <div className="sfm-save-row">
                <button type="button" className="button primary" onClick={handleSave} disabled={saving}>Save Custom Text</button>
                <Feedback feedback={feedback} />
            </div>
        </div>
    );
}
